import { ParamMappingType } from '@app/pages/clients-and-matters/enums/clients-and-matters.enums';
import { SearchOptionsValue } from '@app/shared/components/new-drawer/new-drawer.enums';

const CONTACTS_SEARCH_FORM_FIELD_TO_TYPE_MAP: Record<string, ParamMappingType> = {
	client: ParamMappingType.Object,
	contactName: ParamMappingType.String,
	companyName: ParamMappingType.String,
	taxId: ParamMappingType.String,
	departmentName: ParamMappingType.String,
	position: ParamMappingType.String,
	email: ParamMappingType.String,
	phoneNumber: ParamMappingType.PhoneNumber,
	fax: ParamMappingType.PhoneNumber,
	address: ParamMappingType.String
};

const EMPLOYEES_SEARCH_FORM_FIELD_TO_TYPE_MAP: Record<string, ParamMappingType> = {
	isActive: ParamMappingType.Single,
	branch: ParamMappingType.Branch,
	department: ParamMappingType.Array,
	employeeName: ParamMappingType.String,
	role: ParamMappingType.Object,
	email: ParamMappingType.String,
	phoneNumber: ParamMappingType.PhoneNumber,
	extension: ParamMappingType.String,
	fax: ParamMappingType.PhoneNumber,
	location: ParamMappingType.String,
	floor: ParamMappingType.String
};

const COMPANIES_SEARCH_FORM_FIELD_TO_TYPE_MAP: Record<string, ParamMappingType> = {
	phoneNumber: ParamMappingType.PhoneNumber,
	address: ParamMappingType.String,
	email: ParamMappingType.String
};

const RECIPIENTS_SEARCH_FORM_FIELD_TO_TYPE_MAP: Record<string, ParamMappingType> = {
	recipientName: ParamMappingType.String,
	email: ParamMappingType.String,
	address: ParamMappingType.String,
	taxId: ParamMappingType.String
};

export const ITEM_TO_PARAM_MAP: Record<SearchOptionsValue, any> = {
	[SearchOptionsValue.Contacts]: CONTACTS_SEARCH_FORM_FIELD_TO_TYPE_MAP,
	[SearchOptionsValue.Employees]: EMPLOYEES_SEARCH_FORM_FIELD_TO_TYPE_MAP,
	[SearchOptionsValue.Companies]: COMPANIES_SEARCH_FORM_FIELD_TO_TYPE_MAP,
	[SearchOptionsValue.Recipients]: RECIPIENTS_SEARCH_FORM_FIELD_TO_TYPE_MAP
};
